import { Logo } from "./Logo";
import { CONTACTS, SERVICES } from "../data/services";

export const Footer = () => (
  <footer className="bg-black border-t border-white/10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <Logo size={52} />
        <p className="mt-5 font-display font-black uppercase text-2xl text-white tracking-wide">
          Pelu So <span className="text-[#FFD500]">Service</span>
        </p>
        <p className="mt-2 text-sm text-neutral-500 max-w-sm leading-relaxed">
          Il servizio che cercavi. Edilizia, lavori in quota e multiservizi a Roma e Monterotondo, con assistenza H24 sette giorni su sette.
        </p>
      </div>

      <div>
        <p className="font-mono-tac text-[10px] tracking-[0.25em] uppercase text-[#FFD500] mb-4">Servizi</p>
        <ul className="space-y-2">
          {SERVICES.slice(0, 6).map((s) => (
            <li key={s.id}>
              <a href="#servizi" className="text-sm text-neutral-400 hover:text-[#FFD500] transition-colors duration-300">
                {s.title}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="font-mono-tac text-[10px] tracking-[0.25em] uppercase text-[#FFD500] mb-4">Contatti</p>
        <ul className="space-y-2 text-sm text-neutral-400">
          <li><a href={CONTACTS.sede.href} className="hover:text-[#FFD500] transition-colors duration-300">{CONTACTS.sede.number}</a></li>
          <li><a href={CONTACTS.diretto.href} className="hover:text-[#FFD500] transition-colors duration-300">{CONTACTS.diretto.number}</a></li>
          <li><a href={`mailto:${CONTACTS.email}`} className="hover:text-[#FFD500] transition-colors duration-300">{CONTACTS.email}</a></li>
          {CONTACTS.addresses.map((a) => (
            <li key={a.city} className="text-neutral-500 text-xs pt-1">{a.address}</li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono-tac text-[10px] tracking-widest text-neutral-600 uppercase" data-testid="footer-copyright">
          © 2026 Peluso Service di Daniele Peluso — Tutti i diritti riservati
        </p>
        <p className="font-mono-tac text-[10px] tracking-widest text-neutral-600 uppercase">
          H24 · 7 giorni su 7
        </p>
      </div>
    </div>
  </footer>
);
